import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useContext } from 'react';

import styles from './index.module.scss';
import { MissionTableProvider, MissionTableContext } from './MissionTableContext';
import ProjectRow from './ProjectRow';

import EmptyList from '@/components/ui/EmptyList';
import ModalSpinner from '@/components/ui/ModalSpinner';

const cx = classNames.bind(styles);

const MissionTableContent = ({ className }) => {
  const { projects, load } = useContext(MissionTableContext);

  useMountEffect(() => {
    load();
  });

  return (
    <div className={cx(['container', className])}>
      {!projects && <ModalSpinner />}
      {projects?.length === 0 && (
        <div className={cx('empty')}>
          <EmptyList />
        </div>
      )}
      {projects?.length > 0 && (
        <div className={cx('groups')}>
          {projects.map((project) => (
            <ProjectRow key={project.id} project={project} />
          ))}
        </div>
      )}
    </div>
  );
};

const MissionTable = ({ onSelectProject, onSelectMission, showMissionEdit = false, className }) => (
  <MissionTableProvider
    onSelectProject={onSelectProject}
    onSelectMission={onSelectMission}
    showMissionEdit={showMissionEdit}>
    <MissionTableContent className={className} />
  </MissionTableProvider>
);

export default MissionTable;
export { MissionTableContent };
